import { render } from "./ColorSelect.vue?vue&type=template&id=1cc88c21"
import script from "./ColorSelect.vue?vue&type=script&lang=js"
export * from "./ColorSelect.vue?vue&type=script&lang=js"

import "./ColorSelect.vue?vue&type=style&index=0&id=1cc88c21&lang=css"

import exportComponent from "/var/www/html/projects/rde/resources/vueapps/quotation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__